export default __webpack_public_path__ + "static/BasierCircle-SemiBoldItalic-a974054c9963005ccfb9abb956780038.woff2";